import { CommandId } from './commandSpecs';
import type { KeyManager } from '@reactive';

export enum DragType {
  CONNECT = 'connect',
  SELECT = 'select',
  ARRANGE = 'arrange',
  PAN = 'pan'
}

// https://www.w3schools.com/cssref/pr_class_cursor.php
export const Cursor = {
  DEFAULT: 'default',
  POINTER: 'pointer',
  PAN: 'grab',
  PANNING: 'grabbing',
  SELECT: 'cell',
  CONNECT: 'default',
  ARRANGE: 'all-scroll',
  CROSSHAIR: 'crosshair',
  HIDDEN: 'none'
};

export class ToolManager {
  keyManager: KeyManager;
  tools: CommandId[] = [];
  primaryTool = $state(CommandId.TOOL_CREATE);
  momentaryTool = $state<CommandId | undefined>(undefined);

  private startSelectToolTime: DOMHighResTimeStamp | undefined;

  activeTool = $derived.by(() => {
    return this.momentaryTool ?? this.primaryTool;
  });

  constructor(keyManager: KeyManager) {
    this.keyManager = keyManager;
    this.addTool(CommandId.TOOL_CREATE);
    this.addTool(CommandId.TOOL_SELECT);
    this.addTool(CommandId.TOOL_ARRANGE);
    this.addTool(CommandId.TOOL_PAN);
  }

  addTool(id: CommandId) {
    this.tools.push(id);
  }

  selectTool(id: CommandId) {
    this.primaryTool = id;
  }

  startSelectTool(id: CommandId) {
    this.startSelectToolTime = performance.now();
    this.momentaryTool = id;
  }

  endSelectTool() {
    if (this.startSelectToolTime && performance.now() - this.startSelectToolTime < 200) {
      this.primaryTool = this.momentaryTool ?? this.primaryTool;
    }
    this.momentaryTool = undefined;
  }
}
